import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id D6AD70EE-33F4-4C3A-8ED1-3CD3236222F8
 * name tooltip
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tooltip.svg
 * tags
 * - Tooltip 
 */
export const TooltipIcon = createSvgIcon(<><path d="M4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H16L12,22L8,18H4A2,2 0 0,1 2,16V4A2,2 0 0,1 4,2Z" /></>, 'TooltipIcon');
export default TooltipIcon